"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Styled = __importStar(require("./Paginator.style"));
var helpers_1 = require("./helpers");
function Paginator(_a) {
    var pageSize = _a.pageSize, pageIndex = _a.pageIndex, displayedRange = _a.displayedRange, itemCount = _a.itemCount, onClick = _a.onClick;
    var _b = helpers_1.buildPagination(pageSize, pageIndex, displayedRange, itemCount), totalPages = _b.totalPages, rangeStart = _b.rangeStart, rangeEnd = _b.rangeEnd, nextPage = _b.nextPage, previousPage = _b.previousPage;
    var hasPrev = previousPage != null;
    var hasNext = nextPage != null;
    var distanceFromLastPage = totalPages - rangeEnd - 1;
    var modifiedRangeStart = distanceFromLastPage === 0
        ? Math.max(0, rangeEnd - displayedRange)
        : rangeStart;
    var pageButtons = Array(rangeEnd - modifiedRangeStart + 1)
        .fill(modifiedRangeStart)
        .map(function (r, index) {
        var page = r + index;
        var clickHandler = function () {
            onClick(page);
        };
        return (react_1.default.createElement(Styled.PageButton, { key: page, onClick: clickHandler, isActive: page === pageIndex }, page + 1));
    });
    var firstClickHandler = function () {
        onClick(0);
    };
    var prevClickHandler = function () {
        onClick(previousPage);
    };
    var nextClickHandler = function () {
        onClick(nextPage);
    };
    var lastClickHandler = function () {
        onClick(totalPages - 1);
    };
    return (react_1.default.createElement(Styled.Paginator, null,
        react_1.default.createElement(Styled.PageButton, { disabled: !hasPrev, onClick: firstClickHandler, isActive: false },
            react_1.default.createElement(Styled.Icon, { name: "doubleArrowLeft", color: hasPrev ? 'lqBlue' : 'regentGray' })),
        react_1.default.createElement(Styled.PageButton, { disabled: !hasPrev, onClick: prevClickHandler, isActive: false },
            react_1.default.createElement(Styled.Icon, { name: "arrowLeft", color: hasPrev ? 'lqBlue' : 'regentGray' })),
        pageButtons,
        distanceFromLastPage > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            distanceFromLastPage > 1 && react_1.default.createElement("span", null, "..."),
            react_1.default.createElement(Styled.PageButton, { isActive: false, onClick: lastClickHandler }, totalPages))),
        react_1.default.createElement(Styled.PageButton, { disabled: !hasNext, onClick: nextClickHandler, isActive: false },
            react_1.default.createElement(Styled.Icon, { name: "arrowRight", color: hasNext ? 'lqBlue' : 'regentGray' })),
        react_1.default.createElement(Styled.PageButton, { disabled: !hasNext, onClick: lastClickHandler, isActive: false },
            react_1.default.createElement(Styled.Icon, { name: "doubleArrowRight", color: hasNext ? 'lqBlue' : 'regentGray' }))));
}
exports.default = Paginator;
//# sourceMappingURL=Paginator.js.map